import "./HomePageGrid.css";
import styled from "styled-components";
import { searchClientIndex } from "App";
import { useQuery, useSearch, useSearchContext } from "@sajari/react-hooks";
import { useHistory, Link } from "react-router-dom";

export default function HomePageGridComponent() {
  const { query, setQuery } = useQuery();
  const history = useHistory();
  const { searched } = useSearchContext();
  const { results = [] } = useSearch();

  const handleChangeCategory = (category: any) => {
    setQuery(category);
    history.push({
      pathname: "/search-results",
      search: `?${"q"}=${category}`,
      state: {
        searched: searched,
        results: results,
      },
    });
  };

  return (
    <div className="home-page-container">
      <div className="home-page-grid">
        <div className="home-page-card">
          <div className="card-content-wrapper">
            <div>
              <div className="home-page-card-title">Fragrant Perfumes</div>
              <img
                className="home-page-card-images"
                src="https://storage.googleapis.com/content.paysfer.com/paysfer_pictures/homepage_perfumes.webp"
                alt=""
                onClick={() => {
                  handleChangeCategory("perfumes");
                }}
                loading="lazy"
              />
              <span
                className="home-page-more-button"
                onClick={() => {
                  handleChangeCategory("perfumes");
                }}
              >
                Shop more perfumes
              </span>
            </div>
          </div>
        </div>
        <div className="home-page-card">
          <div className="card-content-wrapper">
            <div>
              <div className="home-page-card-title">
                Luxurious Men's & Women's Watches
              </div>
              <img
                className="home-page-card-images"
                src="https://storage.googleapis.com/content.paysfer.com/paysfer_pictures/homepage_watches.webp"
                alt=""
                onClick={() => {
                  handleChangeCategory("watches");
                }}
                loading="lazy"
              />
              <span
                className="home-page-more-button"
                onClick={() => {
                  handleChangeCategory("watches");
                }}
              >
                Shop more watches
              </span>
            </div>
          </div>
        </div>
        <div className="home-page-card">
          <div className="card-content-wrapper">
            <div>
              <div className="home-page-card-title">
                Beautiful Australian Scarves
              </div>
              <img
                className="home-page-card-images"
                src="https://storage.googleapis.com/content.paysfer.com/paysfer_pictures/homepage_scarves.webp"
                alt=""
                onClick={() => {
                  handleChangeCategory("scarves");
                }}
                loading="lazy"
              />
              <span
                className="home-page-more-button"
                onClick={() => {
                  handleChangeCategory("scarves");
                }}
              >
                Shop more scarves
              </span>
            </div>
          </div>
        </div>
        <div className="home-page-card">
          <div className="card-content-wrapper">
            <div>
              <div className="home-page-card-title">
                Elegant & Fine Jewelries
              </div>
              <img
                className="home-page-card-images"
                src="https://storage.googleapis.com/content.paysfer.com/paysfer_pictures/homepage_jewelry.webp"
                alt=""
                onClick={() => {
                  handleChangeCategory("jewelry");
                }}
                loading="lazy"
              />
              <span
                className="home-page-more-button"
                onClick={() => {
                  handleChangeCategory("jewelry");
                }}
              >
                Shop more jewelries
              </span>
            </div>
          </div>
        </div>
        <div className="home-page-card">
          <div className="card-content-wrapper">
            <div>
              <div className="home-page-card-title">Gold & Silver Bullion</div>
              <img
                className="home-page-card-images"
                src="https://storage.googleapis.com/content.paysfer.com/assets2/RJ_BULLION_TILE.jpg"
                alt=""
                onClick={() => {
                  handleChangeCategory("RJ Bullion");
                }}
                loading="lazy"
              />
              <span
                className="home-page-more-button"
                onClick={() => {
                  handleChangeCategory("RJ Bullion");
                }}
              >
                Shop more gold and silver bullion
              </span>
            </div>
          </div>
        </div>
        <img
          className="home-page-banner"
          src={
            "https://storage.googleapis.com/content.paysfer.com/banner/Paysfer%20eGift%20Cards.webp"
          }
          alt=""
          onClick={() => {
            history.push("/paysfer-gift-card");
          }}
          loading="lazy"
        />
      </div>
    </div>
  );
}
